var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg-creme-50"},[_c('HiwTopSection'),_c('HiwTimeline')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }